import React, { useContext, useState } from "react";

import CheckoutOverlay from "../CheckoutOverlay";
import Margin from "../Margin";
import NewHeadline from "../NewHeadline";
import TextAlign from "../TextAlign";

const OrderChangableDetail = ({
    label = false,
    value = false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick = () => {},
    changeContent = false,
    onOverlayInit,
    gtag,
    DataContext,
    readOnly = false,
}) => {
    const dataContext = useContext(DataContext);
    const { formErrors, overlayContent } = dataContext.data;
    const { overlayBack, overlaySave } = dataContext.actions;
    const [overlayVisible, setOverlayVisible] = useState(false);

    const onButtonClick = () => {
        if (changeContent === false && onClick) {
            onClick();
        }
        setOverlayVisible(true);
    };

    return (
        <React.Fragment>
            <div>
                <Margin
                    className="columns is-mobile"
                    {...(label !== false && value !== false ? { top: 20 } : {})}
                >
                    <div className="column is-two-thirds">
                        {value ? <NewHeadline>{label}</NewHeadline> : label}
                    </div>
                    <TextAlign align="right" className="column is-one-third">
                        {!readOnly && (
                            <a
                                onClick={onButtonClick}
                                {...(gtag ? { "data-gtag": gtag } : {})}
                                style={{
                                    fontSize: "12px",
                                    color: "#464646",
                                    textDecoration: "underline",
                                }}
                            >
                                <span>Ändern</span>
                            </a>
                        )}
                    </TextAlign>
                </Margin>
                {value && <div style={{ marginTop: "-25px" }}>{value}</div>}
            </div>
            {overlayVisible && changeContent && (
                <CheckoutOverlay
                    visible={overlayVisible}
                    onInit={onOverlayInit}
                    withButtons
                    buttonNext="Speichern"
                    onPrevious={() => {
                        overlayBack();
                        setOverlayVisible(false);
                    }}
                    showOverflow={overlayContent === "lieferadresse:adresse"}
                    onNext={() => {
                        if (formErrors.length === 0) {
                            overlaySave();
                            setOverlayVisible(false);
                        }
                    }}
                >
                    {changeContent}
                </CheckoutOverlay>
            )}
        </React.Fragment>
    );
};

export default OrderChangableDetail;
